const PageTitles = {
    '/': 'Login | Clanbridge',
    '/dashboard': 'Dashboard | Clanbridge',
    '/masters/company': 'Masters | Clanbridge',
    '/enquiry/pre-registration': 'Booking | Payments',
    '/service&ticket/complaint': 'Service | Complaint',
    '/operations/housekeepin': 'Operations',
    '/inventory/inward-outward': 'Store | Inventory',
    '/GRNMst': 'Goods Receipt Note | Clanbridge',
    '/accounts': 'Finance | Accounts',
    '/assetalloc': 'Asset Allocation | Clanbridge',
    '/reports/dailysummaryreport': 'Reports | Summary',
    '/bedcategorysummary': 'MonthWiseBed Availablity | Clanbridge',
    '/userpermission': 'User Permission',
    '/refundtable': 'Payment Voucher | Clanbridge',
    '/refund': 'Payment Voucher | Clanbridge'
};

export default PageTitles;